import { signal } from 'services/SignalsService'
import { timings } from 'settings/custom/freespins'

const name = 'TransitionBonus'

function execute() {
  const freespinModel = game.models.FreespinModel.get()

  if(timings.hasOwnProperty('transitionBonus') &&  freespinModel.left){
    signal.dispatch('TRANSITION-BONUS-ANIM', true)
  }
  else {
    return Promise.resolve()
  }

  return signal.promise('TRANSITION-BONUS-ANIM:DONE')
}

export function getTransitionBonusAction() {
  return {
    name,
    execute,
  }
}
